module.exports = __webpack_public_path__ + "img/Frame-7.25ca5739.svg";